import React, { useState } from 'react';

const VideoSection = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const videos = [
    {
      id: 1,
      title: "Fully automatic 4 stage Ultrasonic cleaning machine with single head basket transfer system",
      videoUrl: require("../assets/video/fullauto4stagesinglebasket.mp4"),
      thumbnail: require("../assets/video/thumbnails/fullauto4stagesinglebasket.jpg"),
    },
    {
      id: 2,
      title: "Fully automatic 7 stage ultrasonic cleaning machine with multiple basket transfers system, offers increase in productivity by 4-5 times that of conventional single basket transfer system.",
      videoUrl: require("../assets/video/fullauto7stagemulti.mp4"),
      thumbnail: require("../assets/video/thumbnails/fullauto7stagemulti.jpg"),
    },
    {
      id: 3,
      title: "2 stage Ultrasonic cleaning machine with Dunking & automatic basket lifting options",
      videoUrl: require("../assets/video/2stageautodunking.mp4"),
      thumbnail: require("../assets/video/thumbnails/2stageautodunking.jpg"),
    }
  ];

  // Simulate loading state
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold sm:text-4xl bg-gradient-to-r from-green-300 via-blue-500 to-purple-600 bg-clip-text text-transparent mx-auto pb-4 text-center">Featured Videos</h2>        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-8">
          {isLoading ? (
            // Loading skeleton
            Array(3).fill(0).map((_, index) => (
              <div key={`skeleton-${index}`} className="bg-white rounded-lg shadow-md overflow-hidden animate-pulse">
                <div className="aspect-video bg-gray-200" />
                <div className="p-4">
                  <div className="h-4 bg-gray-200 rounded w-3/4 mb-4" />
                  <div className="h-3 bg-gray-200 rounded w-1/2" />
                </div>
              </div>
            ))
          ) : (
            videos.map((video) => (
              <div key={video.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="aspect-video relative group">
                  {/* Video preview */}
                  <video 
                    className="w-full h-full object-cover"
                    poster={video.thumbnail}
                    onMouseOver={(e) => e.target.play()}
                    onMouseOut={(e) => {
                      e.target.pause();
                      e.target.currentTime = 0;
                    }}
                    muted
                    loop
                  >
                    <source src={video.videoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  
                  {/* Hover overlay */}
                  <div className="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <button 
                      onClick={() => setSelectedVideo(video)}
                      className="w-16 h-16 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transform hover:scale-110 transition-all duration-300"
                      aria-label="Play video"
                    >
                      {/* Play icon */}
                      <svg 
                        className="w-8 h-8 text-gray-900" 
                        fill="currentColor" 
                        viewBox="0 0 20 20"
                      >
                        <path d="M6.3 2.841A1.5 1.5 0 004 4.11v11.78a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
                      </svg>
                    </button>
                  </div>
                </div>

                <div className="p-4">
                  <h3 className="font-semibold text-lg mb-2 line-clamp-2">{video.title}</h3>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Video Modal */}
      {selectedVideo && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="relative w-full max-w-4xl bg-black rounded-lg overflow-hidden">
            {/* Close button */}
            <button
              onClick={() => setSelectedVideo(null)}
              className="absolute top-4 right-4 text-white hover:text-gray-300 z-10"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Video player */}
            <div className="aspect-video">
              <video
                className="w-full h-full"
                controls
                autoPlay
                src={selectedVideo.videoUrl}
              >
                <source src={selectedVideo.videoUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default VideoSection;